var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment"},[_c('div',{staticClass:"container"},[_c('StripeMethod',{attrs:{"coupon":_vm.coupon,"plan":_vm.$route.params.plan,"new-plans-style":""},on:{"success":_vm.onSuccess}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }